import React from 'react';
import { Section, Container } from '../common';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import packageInfo from '../../../package.json';

const Footer = () => {
  return (
    <>
      <Section className="bg-primary-custom py-5">
        <Container className="text-center">
          <h2 className="fw-bold mb-3">Pronto para vender mais?</h2>
          <p className="lead mb-5">Crie seu cardápio digital agora e comece a receber pedidos online em poucos minutos.</p>
          <a href="/cadastro" className="btn btn-lg px-5 shadow text-dark bg-white border-white fw-bold">Criar meu cardápio</a>
        </Container>
      </Section>

      <footer className="bg-black-soft text-white py-5">
        <Container>
          <div className="row g-4">
            <div className="col-lg-4">
              <div className="d-flex align-items-center mb-4">
                <img src="/logo-leo-delivery-minimalist.png" alt="Léo Delivery Logo" style={{ height: '50px', width: 'auto' }} className="me-2 rounded-2" />
                <span className="fw-bold h4 mb-0 text-primary-custom">Léo Delivery</span>
              </div>
              <p className="text-white-50">
                A solução completa para transformar seu restaurante em uma máquina de vendas online.
              </p>
              <div className="d-flex gap-3">
                <a href="https://facebook.com/leodelivery" target="_blank" rel="noopener noreferrer" className="text-white-50"><Facebook size={20} /></a>
                <a href="https://instagram.com/leodelivery.app" target="_blank" rel="noopener noreferrer" className="text-white-50"><Instagram size={20} /></a>
                <a href="https://twitter.com/leodelivery" target="_blank" rel="noopener noreferrer" className="text-white-50"><Twitter size={20} /></a>
                <a href="https://linkedin.com/company/leodelivery" target="_blank" rel="noopener noreferrer" className="text-white-50"><Linkedin size={20} /></a>
              </div>
            </div>
            
            <div className="col-sm-6 col-lg-2 offset-lg-1">
              <h5 className="fw-bold mb-4 text-primary-custom">Produto</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="#funcionalidades" className="text-white-50 text-decoration-none">Funcionalidades</a></li>
                <li className="mb-2"><a href="#segmentos" className="text-white-50 text-decoration-none">Segmentos</a></li>
                <li className="mb-2"><a href="#planos" className="text-white-50 text-decoration-none">Planos</a></li>
                <li className="mb-2"><a href="#faq" className="text-white-50 text-decoration-none">FAQ</a></li>
                <li className="mb-2"><a href="#inicio" className="text-white-50 text-decoration-none">Integrações</a></li>
              </ul>
            </div>

            <div className="col-sm-6 col-lg-2">
              <h5 className="fw-bold mb-4 text-primary-custom">Empresa</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="#inicio" className="text-white-50 text-decoration-none">Sobre</a></li>
                <li className="mb-2"><a href="/blog" className="text-white-50 text-decoration-none">Blog</a></li>
                <li className="mb-2"><a href="#contato" className="text-white-50 text-decoration-none">Contato</a></li>
                <li className="mb-2"><a href="#inicio" className="text-white-50 text-decoration-none">Suporte</a></li>
                <li className="mb-2"><a href="/download-app-driver" className="text-white-50 text-decoration-none">Seja entregador</a></li>
              </ul>
            </div>
            
            <div className="col-sm-6 col-lg-3">
              <h5 className="fw-bold mb-4 text-primary-custom">Legal</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="/termos-de-uso.html" className="text-white-50 text-decoration-none">Termos de uso</a></li>
                <li className="mb-2"><a href="/politica-de-privacidade.html" className="text-white-50 text-decoration-none">Política de privacidade</a></li>
                <li className="mb-2"><a href="/exclusao-de-dados.html" className="text-white-50 text-decoration-none">Exclusão de dados</a></li>
              </ul>
            </div>
          </div>
          
          <hr className="my-5 border-secondary" />
          
          <div className="text-center text-white-50 small">
            <p className="mb-1">© {new Date().getFullYear()} Léo Delivery. Todos os direitos reservados.</p>
            <p className="mb-1">CNPJ: 55.234.781/0001-70</p>
            <p className="mb-0">Versão: v{packageInfo.version}</p>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
